// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8CLRB","top":"styles_top__1ejDt","left":"styles_left__1VdYt","description":"styles_description__E2aiu"};